import Link from '@components/ui/link'
import { ButtonHTMLAttributes, PropsWithChildren } from 'react'

interface Props {
  href: string
  btnPropsLogin: ButtonHTMLAttributes<any>
  btnPropsRegister: ButtonHTMLAttributes<any>
  isAuthorized: boolean
}

export default function AuthMenu({
  isAuthorized,
  href,
  btnPropsLogin,
  btnPropsRegister,
  children,
}: PropsWithChildren<Props>) {
  return isAuthorized ? (
    <Link
      href={href}
      className="text-sm font-normal lg:text-15px text-white focus:outline-none ltr:ml-2 rtl:mr-2"
    >
      {children}
    </Link>
  ) : (
    <>
      <button
        className="text-sm pr-1 font-normal lg:text-15px text-brand-dark focus:outline-none ltr:ml-2 hover:underline"
        // aria-label={String(btnProps.children)}
        {...btnPropsLogin}
      />
      {btnPropsRegister && (
        <>
          {'/'}
          <button
            className="text-sm pl-1 font-normal lg:text-15px text-brand-dark focus:outline-none hover:underline"
            // aria-label={String(btnPropsRegister.children)}
            {...btnPropsRegister}
          />
        </>
      )}
    </>
  )
}
